import { appConfig } from '../../../../config'
import { BookHealthCallRequest, HealthCallAppointment, HealthCallSummary } from './types'

export const getHealthCallSummary = async ({ accessToken }: { accessToken: string }): Promise<HealthCallSummary> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthCalls/summary`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to fetch health call summary')
  }

  return res.json()
}

export const getHealthCallAppointment = async ({
  accessToken,
}: {
  accessToken: string
}): Promise<HealthCallAppointment | null> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthCalls`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to fetch health call appointment')
  }

  const { healthCall } = await res.json()
  return healthCall
}

export const patchCancelHealthCall = async ({
  accessToken,
  appointmentId,
}: {
  accessToken: string
  appointmentId: string
}): Promise<Response> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthCalls/${appointmentId}/cancel`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to cancel health call appointment')
  }
  return res
}

export const postBookHealthCall = async ({
  accessToken,
  bookingData,
}: {
  accessToken: string
  bookingData: BookHealthCallRequest
}): Promise<Response> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthCalls/book`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(bookingData),
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))

    if (res.status === 400 && data?.code === 'TIMESLOT_TOO_CLOSE') {
      throw new Error('TIMESLOT_TOO_CLOSE')
    }

    if (res.status === 400 && data?.code === 'JOURNAL_CONSENT_REQUIRED') {
      throw new Error('JOURNAL_CONSENT_REQUIRED')
    }

    if (res.status === 409) {
      throw new Error(data?.message || 'This timeslot has already been booked. Please select another time.')
    }

    throw new Error(data?.message || 'Failed to book health call appointment')
  }
  return res
}
